var SubscriptionLog = /*@__PURE__*/function () {
  function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
    if (unsubscribedFrame === void 0) {
      unsubscribedFrame = Number.POSITIVE_INFINITY;
    }
    this.subscribedFrame = subscribedFrame;
    this.unsubscribedFrame = unsubscribedFrame;
  }
  return SubscriptionLog;
}();
export { SubscriptionLog };